module.exports = __webpack_public_path__ + "img/about-us.1fa39d5c.jpg";